(() => {
  const root = document.querySelector('[data-blanket-page]');
  if (!root) return;
  const params = new URLSearchParams(location.search);
  const rawId = params.get('design_id') || '';
  const designId = /^[A-Za-z0-9][A-Za-z0-9_-]{0,127}$/.test(rawId) ? rawId : '';
  const wholesale = params.get('intent') === 'wholesale';
  const orderForm = root.querySelector('#BlanketRetailForm');
  const quoteForm = root.querySelector('#CustomProductQuote');
  let previewUrl = null;
  if (designId && params.get('preview_url')) {
    try {
      const url = new URL(params.get('preview_url'), location.origin);
      const path = '/apps/customizer/api/blanket/designs/' + encodeURIComponent(designId) + '/preview';
      if (url.origin === location.origin && url.pathname === path && !url.search && !url.hash) previewUrl = url;
    } catch { /* The saved design remains usable without a preview. */ }
  }

  // Preserve a theme preview when testing the designer round trip.
  root.querySelectorAll('[data-customizer-launcher]').forEach(link => {
    const destination = new URL('/pages/print-your-own-blanket', location.origin);
    ['preview_theme_id', 'pb'].forEach(key => {
      if (params.has(key)) destination.searchParams.set(key, params.get(key));
    });
    const launcher = new URL(link.href, location.origin);
    launcher.searchParams.set('return_to', destination.pathname + destination.search);
    link.href = launcher.href;
    link.dataset.returnTo = destination.pathname + destination.search;
  });

  if (designId) {
    root.querySelectorAll('[data-blanket-design-id]').forEach(el => { el.textContent = designId; });
    root.querySelector('[data-blanket-saved]').hidden = false;
    root.querySelector('[data-blanket-wholesale-design]').hidden = false;
    root.querySelector('#BlanketDesignId').value = designId;
    if (wholesale) root.querySelector('[data-blanket-saved-next]').textContent = 'Your design is attached to the wholesale enquiry below.';
    if (quoteForm) {
      const action = new URL(quoteForm.action, location.origin);
      action.searchParams.set('design_id', designId);
      action.searchParams.set('intent', 'wholesale');
      quoteForm.action = action.href;
      const returnField = document.createElement('input');
      returnField.type = 'hidden'; returnField.name = 'return_to';
      const returnUrl = new URL(location.href);
      returnUrl.searchParams.delete('contact_posted');
      returnUrl.searchParams.set('intent', 'wholesale');
      returnUrl.hash = 'blanket-wholesale';
      returnField.value = returnUrl.pathname + returnUrl.search + returnUrl.hash;
      quoteForm.appendChild(returnField);
    }
    const submitted = root.querySelector('[data-blanket-quote-success]') || params.get('contact_posted') === 'true';
    if (!submitted) {
      const focusNext = () => {
        const target = root.querySelector(wholesale ? '#blanket-wholesale' : '#blanket-retail');
        (wholesale ? root.querySelector('#CustomName') : root.querySelector('[data-blanket-option="0"]'))?.focus({ preventScroll: true });
        target.scrollIntoView({ behavior: 'auto', block: 'start' });
      };
      if (document.readyState === 'complete') requestAnimationFrame(focusNext);
      else window.addEventListener('load', focusNext, { once: true });
    }
  }

  if (previewUrl) {
    const preview = root.querySelector('[data-blanket-preview]');
    fetch(previewUrl.href, { credentials: 'same-origin', redirect: 'error' })
      .then(response => {
        const type = (response.headers.get('content-type') || '').split(';')[0].trim().toLowerCase();
        return response.ok && ['image/png', 'image/jpeg', 'image/webp'].includes(type) ? response.blob() : null;
      })
      .then(blob => {
        if (!blob) return;
        const objectUrl = URL.createObjectURL(blob);
        preview.addEventListener('load', () => { preview.hidden = false; URL.revokeObjectURL(objectUrl); }, { once: true });
        preview.addEventListener('error', () => { preview.hidden = true; preview.removeAttribute('src'); URL.revokeObjectURL(objectUrl); }, { once: true });
        preview.src = objectUrl;
      }).catch(() => { /* Keep the saved design reference when its preview is unavailable. */ });
  }
  if (!orderForm) return;
  const variants = JSON.parse(root.querySelector('[data-blanket-variants]').textContent);
  const currency = JSON.parse(root.querySelector('[data-blanket-currency]').textContent) || 'USD';
  const optionNodes = [...orderForm.querySelectorAll('[data-blanket-option]')];
  const variantInput = orderForm.querySelector('[data-blanket-variant]');
  const button = orderForm.querySelector('[data-blanket-add]');
  const price = orderForm.querySelector('[data-blanket-price]');
  const total = orderForm.querySelector('[data-blanket-total]');
  const quantity = orderForm.querySelector('#BlanketQuantity');
  const artwork = orderForm.querySelector('#BlanketArtwork');
  const back = orderForm.querySelector('#BlanketBack');
  const status = orderForm.querySelector('[data-blanket-cart-status]');
  const initialVariant = variants.find(variant => String(variant.id) === params.get('variant'))
    || variants.find(variant => String(variant.id) === variantInput.value);
  if (initialVariant) {
    optionNodes.forEach(el => {
      const value = initialVariant.options[Number(el.dataset.blanketOption)];
      if (el.type === 'radio') el.checked = el.value === value;
      else el.value = value;
    });
  }
  let selectedVariant;
  let currentLayer;
  let adding = false;
  const setProperty = (selector, value) => {
    const el = orderForm.querySelector(selector);
    el.value = value || ''; el.disabled = !value;
  };
  setProperty('[data-blanket-order-design]', designId);
  setProperty('[data-blanket-order-preview]', previewUrl?.href);
  const canvas = params.get('canvas_size') || '';
  setProperty('[data-blanket-order-canvas]', designId && /^(40x60|50x70|60x80)$/.test(canvas) ? canvas : '');
  artwork.required = !designId;
  if (designId) {
    root.querySelector('[data-blanket-artwork-required]').textContent = '(optional — saved design attached)';
    root.querySelector('[data-blanket-artwork-help]').textContent = 'Your saved artwork is attached to this order. Add a link only if you have an additional production file.';
  }
  const validArtwork = () => {
    if (designId && !artwork.value.trim()) return true;
    try { return ['https:', 'http:'].includes(new URL(artwork.value.trim()).protocol); } catch { return false; }
  };
  const update = () => {
    const values = [0, 1, 2].map(index => optionNodes.find(el => Number(el.dataset.blanketOption) === index && (el.type !== 'radio' || el.checked))?.value);
    selectedVariant = variants.find(variant => variant.options.every((value, index) => value === values[index]));
    variantInput.value = selectedVariant?.id || '';
    price.textContent = selectedVariant?.money || 'Unavailable';
    if (currentLayer !== values[1]) {
      currentLayer = values[1];
      const doubleLayer = currentLayer === 'Double layer';
      back.replaceChildren(...(doubleLayer ? ['Natural unprinted back', 'Same artwork printed on back'] : ['Natural reverse of front fabric']).map(value => new Option(value, value)));
      root.querySelector('[data-blanket-back-help]').textContent = doubleLayer ? 'Both back options are included in this price. The back uses your selected fabric; natural unprinted colour varies by base.' : 'Single layer has the natural reverse of the printed fabric.';
    }
    const count = Number(quantity.value);
    const validCount = Number.isInteger(count) && count >= 1 && count <= 99;
    total.hidden = !selectedVariant || !validCount || count === 1;
    if (!total.hidden) total.textContent = 'Item subtotal: ' + new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(selectedVariant.price * count / 100);
    button.disabled = adding || !selectedVariant?.available || !validCount;
    button.textContent = adding ? 'Adding…' : selectedVariant?.available ? 'Add to cart' : 'Unavailable';
  };
  optionNodes.forEach(el => el.addEventListener('change', update));
  quantity.addEventListener('input', update);
  artwork.addEventListener('input', () => artwork.setCustomValidity(''));
  orderForm.addEventListener('submit', async event => {
    event.preventDefault();
    if (adding) return;
    artwork.setCustomValidity(validArtwork() ? '' : 'Save your design or add a shareable http(s) artwork link before ordering.');
    update();
    if (!orderForm.reportValidity() || button.disabled) return;
    adding = true; update(); status.hidden = true;
    const payload = new FormData(orderForm);
    // These are UI-only radios. The real Shopify variant defines the specification.
    payload.delete('blanket_size');
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: payload });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Unable to add this blanket. Please try again.');
      location.assign((window.Shopify?.routes?.root || '/') + 'cart');
    } catch (error) {
      status.textContent = error.message || 'Unable to add this blanket. Please try again.';
      status.hidden = false; adding = false; update();
    }
  });
  update();
})();
